import * as React from "react";
import { SVGProps } from "react";
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 20.002a1 1 0 0 1 1 1v4c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-4a1 1 0 1 1 2 0v4c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-4a1 1 0 0 1 1-1ZM15.992 2a1 1 0 0 1 .993.883l.007.117v15.13c1.954-1.644 4.038-3.88 6.215-6.678a1.001 1.001 0 1 1 1.578 1.228c-2.726 3.503-5.339 6.189-7.766 7.982a1.707 1.707 0 0 1-2.045 0c-2.31-1.705-4.79-4.221-7.378-7.486l-.389-.495-.078-.11a1 1 0 0 1 1.656-1.118c2.04 2.62 3.997 4.748 5.84 6.356l.367.315V3a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDownload;
